// v2
export const ERROR_PROCESSING = 'ERROR_PROCESSING';
export const VIRUS_DETECTED = 'VIRUS_DETECTED';
export const PROCESSING = 'PROCESSING';
export const PROCESSED = 'PROCESSED';
export const UPLOADING = 'UPLOADING';
export const ERROR_UPLOADING = 'ERROR_UPLOADING';
export const IN_HUMAN_REVIEW = 'IN_HUMAN_REVIEW';
export const PASSWORD_PROTECTED = 'PASSWORD_PROTECTED';
export const EXCEEDS_MAX_PAGE_COUNT = 'EXCEEDS_MAX_PAGE_COUNT';
